export default {"src":"/_next/static/media/Message_outline_gray.9cf81866.svg","height":18,"width":18};